import gql from 'graphql-tag';

export const updateMockExamStudentDepartment = gql`
  mutation updateMockExamStudentDepartment(
    $roundCode: ID!
    $departmentData: MockExamStudentDepartmentCreateInput!
  ) {
    updateMockExamStudentDepartment(roundCode: $roundCode, departmentData: $departmentData) {
      success
      error
      studentProfile {
        id
        roundCode
      }
    }
  }
`;
